.button {
  all: unset;
  outline: revert;
  box-sizing: border-box;

  border-radius: 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;

  /* transition: all 0.2s ease-in-out; */
  cursor: pointer;

  &:disabled {
    filter: grayscale(100%);
    opacity: 0.6;
    cursor: not-allowed;
  }

  &.block {
    width: 100%;
  }

  &.large {
    min-width: max-content;
    min-height: 2.5rem;

    &:not(.text, .link) {
      padding: 0.5rem 1rem;
    }
  }

  &.medium {
    min-width: max-content;
    min-height: 2rem;

    &:not(.text, .link) {
      padding: 0 0.7rem;
    }
  }

  &.small {
    min-width: max-content;
    font-size: var(--fs-small);

    &:not(.text, .link) {
      padding: 4px 8px;
    }
  }

  &.primary {
    color: white;
    background-color: var(--primary-enabled);
    border-top: 2px solid transparent;
    border-bottom: 2px solid #CB3300;
    margin-bottom: -1px;
  }

  &.primary:not(:disabled):hover {
    background-color: var(--primary-hover);
  }

  &.primary:not(:disabled):active {
    background-color: var(--primary-active);
    border-bottom-color: transparent;
  }

  &.primary:disabled {
    border-bottom-color: transparent;
  }

  &.danger {
    color: var(--danger-enabled-text);
    background-color: var(--danger-enabled);
  }

  &.danger:not(:disabled):hover {
    background-color: var(--danger-hover);
  }

  &.danger:not(:disabled):active {
    background-color: var(--danger-active);
  }

  &.secondary {
    color: var(--static-text-standard);
    background-color: var(--static-background-standard);
    border: 1px solid var(--static-divider-standard);
  }

  &.secondary:not(:disabled):hover {
    background-color: var(--static-background-standard);
  }

  &.secondary:not(:disabled):active {
    background-color: var(--static-background-strong);
  }

  &.inverse {
    color: var(--static-text-inverse-standard);
    background-color: var(--static-background-inverse-weak);
  }

  &.inverse:not(:disabled):hover {
    color: var(--static-text-inverse-strong);
    background-color: var(--static-background-inverse-standard);
  }

  &.inverse:not(:disabled):active {
    background-color: var(--static-background-inverse-strong);
  }

  /* this button should probably go away. */
  &.black {
    color: #fff;
    background-color: #000;
  }

  &.black:hover {
    color: #fff;
    background-color: #111;
  }

  &.text, &.textButton {
    background: transparent;
    color: var(--static-text-strong);
  }

  &.text:not(:disabled):hover, &.textButton:not(:disabled):hover {
    background-color: var(--static-background-strong);
  }

  &.link {
    color: var(--primary-enabled);
    text-decoration: none;
  }

  &.link:not(:disabled):hover {
    color: var(--primary-hover);
  }
}